import React, {Component} from "react";

import Layer1 from "../layers/Layer1"
import Layer2 from "../layers/Layer2"
import Layer3 from "../layers/Layer3/SearchLanding"
import Layer4 from "../layers/Layer4"
import { useParams } from 'react-router-dom'
import useGlobal from "../store";

import "./index.scss";

const Search = (props) => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const q = params.get('q');

    let [currentState, currentActions] = useGlobal();
    if (currentState.currentModule !==  "Search Results") {
        currentActions.setCurrentModule("Search Results")
    }

    return  (
        <div className="ui-main location">
            <Layer1 />
            <Layer2 submodule="Search Results" />
            <Layer3 searchTerm={q} />
            <Layer4 />
        </div>
    )
}

export default Search